import styled from '@emotion/styled'

export const LazyWrapper = styled.span`
  width: 100%;
`
